import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    RouterList:sessionStorage.getItem('role_router'),
  },
  mutations: {
   changeRouter(state,x){
     state.RouterList=x
     console.log(state.RouterList)
   }
  },
  actions: {
  },
  modules: {},
});
